import React, {Component} from 'react';
import {Badge, CardMedia, withStyles} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import i18n from '../../i18n';

const windowConfig = 'toolbar=0,status=0,width=650,height=900';

class PreviewButton extends Component {

    constructor(props) {
        super(props);
        // console.log(this.props.hideCopies);
        this.state = {
            file: this.props.file,
            hideCopies: this.props.hideCopies,
        };
    }

    render() {
        return (
            <Button
                title={i18n.get('file.open_preview')}
                onClick={() => window.open(this.getUrl(), 'docPrev', windowConfig)}>
                <Badge badgeContent={this.state.hideCopies ? '' : (this.getCopies())} color="primary">
                    <CardMedia
                        component={'img'}
                        src={this.getImage()}
                        className={this.props.className}
                    />
                </Badge>
            </Button>
        );
    }

    getUrl() {
        return this.state.file.sRoutePreview || this.state.file.sRoute.replace('/f/', '/f/preview/');
    }

    getCopies() {
        return this.state.file.aRelations && this.state.file.aRelations.length > 0 && this.state.file.aRelations[0] && this.state.file.aRelations[0].copies;
    }

    getImage() {
        return this.state.file.sPrevPic || this.state.file.sRoute + '_200_';
    }
}

const styles = theme => ({});


export default withStyles(styles)(PreviewButton);
